import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductosMediadoresService {
  /**
   * @description constructor
   * @params http
   */
  constructor( private http: HttpClient) {
    this.http = http;
  }
  /**
   * @description Recuperar información de - Productos
   * @params idProveedor
   * @params idSubGrupoProducto
   */
  getProductosMediadores(idProveedor: string, idSubGrupoProducto: string): Observable<any> {
    const header: HttpHeaders = new HttpHeaders()
      .set('accept', 'application/json')
      .set('X-API-Key', environment.apikey);

    const params = 'idProveedor=' + idProveedor + '&idSubGrupoProducto=' + idSubGrupoProducto;
    return this.http.get(
      environment.endpoints.urlBase + environment.endpoints.productosMediadores.name + `?${params}`,
      { headers: header }
    );
  }
}
